import React from 'react';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';

const MaterialMismatchWarning = ({ mismatchData, fieldType = 'both' }) => {
  console.log('MaterialMismatchWarning render:', { mismatchData, fieldType });
  
  // Only display if there's a mismatch
  if (!mismatchData?.hasMismatch) {
    console.log('No mismatch detected, not showing warning');
    return null;
  }

  const { columnMaterial, expectedShaftMaterial, actualShaftMaterial } = mismatchData;

  // Determine the message based on which field is being displayed
  let message = '';
  if (fieldType === 'column') {
    message = `Column Material is ${columnMaterial}, so Shaft Material must be ${expectedShaftMaterial} (currently ${actualShaftMaterial})`;
  } else if (fieldType === 'shaft') {
    message = `Shaft Material is ${actualShaftMaterial}, but Column Material ${columnMaterial} requires ${expectedShaftMaterial}`;
  } else {
    message = `Material Mismatch: ${columnMaterial} column requires ${expectedShaftMaterial} shaft (currently ${actualShaftMaterial})`;
  }

  console.log('MaterialMismatchWarning DISPLAYING with message:', message);

  return (
    <Alert variant="warning" className="mb-2 py-2" style={{ backgroundColor: '#fff3cd', border: '1px solid #ffc107', display: 'block', width: '100%' }}>
      <i className="bi bi-exclamation-triangle me-2"></i>
      <strong>Material Mismatch:</strong> {message}
    </Alert>
  );
};

MaterialMismatchWarning.propTypes = {
  mismatchData: PropTypes.shape({
    hasMismatch: PropTypes.bool,
    columnMaterial: PropTypes.string,
    expectedShaftMaterial: PropTypes.string,
    actualShaftMaterial: PropTypes.string,
  }),
  fieldType: PropTypes.oneOf(['column', 'shaft', 'both']),
};

export default MaterialMismatchWarning;
